// components/journey-surface/journey-timeline.js
// ════════════════════════════════════════════════
// Timeline strip pinned at the bottom of the expanded journey map.
// Renders each node as a small circle in creation order with connecting
// lines. Active/building nodes glow gold; referenced nodes glow purple.

import React from 'react';

export function JourneyTimeline({ nodes, labels, focusedNodeId, onNodeClick }) {
  if (!nodes || nodes.length === 0) return null;
  return (
    <div style={{
      padding: '8px 9px 10px',
      borderTop: '1px solid #1e1e2a',
      flexShrink: 0,
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        marginBottom: 7, fontSize: 9,
        textTransform: 'uppercase', letterSpacing: '0.09em',
        color: '#333', fontFamily: 'Georgia, serif',
      }}>
        <span>Timeline</span>
        {focusedNodeId && (() => {
          const fn = (nodes || []).find(n => n.id === focusedNodeId);
          return fn ? <span style={{ color: '#c8a96e' }}>{labels[fn.id] || ''}</span> : null;
        })()}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
        {[...(nodes || [])].sort((a, b) => {
          const at = a.created_at ? new Date(a.created_at).getTime() : 0;
          const bt = b.created_at ? new Date(b.created_at).getTime() : 0;
          return at - bt;
        }).map((node, i, arr) => {
          const isActive = node.id === focusedNodeId || node.status === 'active';
          const isBuilding = node.status === 'building';
          const isRef = node.status === 'referenced';
          const isError = node.status === 'error';
          const borderColor = isBuilding || isActive ? '#c8a96e'
            : isRef ? '#9b8fc4'
            : isError ? '#c46050'
            : '#222';
          const bgColor = isBuilding || isActive ? 'rgba(200,169,110,0.12)'
            : isRef ? 'rgba(155,143,196,0.08)'
            : isError ? 'rgba(196,96,80,0.08)'
            : '#07070a';
          const textColor = isBuilding || isActive ? '#c8a96e'
            : isRef ? '#9b8fc4'
            : isError ? '#c46050'
            : '#444';
          return (
            <React.Fragment key={node.id}>
              <div
                onClick={() => onNodeClick?.(node)}
                title={node.title}
                style={{
                  width: 20, height: 20, borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 7, flexShrink: 0, cursor: 'pointer',
                  border: `1px solid ${borderColor}`,
                  background: bgColor, color: textColor,
                  fontFamily: 'Georgia, serif', fontWeight: 600,
                  transition: 'transform 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
              >
                {labels[node.id] || ''}
              </div>
              {i < arr.length - 1 && (
                <div style={{
                  flex: 1, height: 1, minWidth: 4,
                  background: isActive || isBuilding
                    ? 'rgba(200,169,110,0.3)' : '#1e1e2a',
                }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
